<template lang="pug">
stock-detail( path-name="TodayHotHistory" )
</template>

<script>
import StockDetail from '@components/stock_detail.vue'
export default {
  components: {
    StockDetail
  }
}
</script>
